import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo.png";
import Button from "react-bootstrap/Button";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { ImBlog } from "react-icons/im";
import {
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
} from "react-icons/ai";
import { CgFileDocument } from "react-icons/cg";
import { SiUpwork } from "react-icons/si";
import { UPWORK_PROFILE } from "../constants/links";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const location = useLocation();

  useEffect(() => {
    function scrollHandler() {
      updateNavbar(window.scrollY >= 20);
    }
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  const navItems = [
    { to: "/", icon: <AiOutlineHome />, label: "Home" },
    { to: "/about", icon: <AiOutlineUser />, label: "About" },
    { to: "/project", icon: <AiOutlineFundProjectionScreen />, label: "Projects" },
    { to: "/blog", icon: <ImBlog />, label: "Blogs" },
    { to: "/resume", icon: <CgFileDocument />, label: "Resume" },
  ];

  return (
    <motion.div
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      <Navbar
        expanded={expand}
        fixed="top"
        expand="md"
        className={navColour ? "sticky" : "navbar"}
      >
        <Container>
          <Navbar.Brand as={Link} to="/" className="d-flex">
            <img src={logo} className="img-fluid logo" alt="brand" />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={() => updateExpanded(expand ? false : "expanded")}
          >
            <span></span>
            <span></span>
            <span></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto" defaultActiveKey="#home">
              {navItems.map((item) => (
                <Nav.Item key={item.to}>
                  <Nav.Link
                    as={Link}
                    to={item.to}
                    onClick={() => updateExpanded(false)}
                    style={
                      location.pathname === item.to
                        ? { color: "var(--text-primary)", background: "rgba(168, 85, 247, 0.12)" }
                        : {}
                    }
                  >
                    {item.icon} {item.label}
                  </Nav.Link>
                </Nav.Item>
              ))}

              <Nav.Item className="fork-btn animated-button">
                <Button
                  href={UPWORK_PROFILE}
                  target="_blank"
                  className="fork-btn-inner"
                >
                  <SiUpwork style={{ fontSize: "1.2em" }} />
                  Hire on Upwork
                </Button>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </motion.div>
  );
}

export default NavBar;
